import type { CancelUserInvitationResponse } from "@/services/frontendServices/usersServices";

/**
 * Only claim the invite link is dead when WorkOS confirmed something: a revoked
 * invitation, a deactivated membership, or a deleted pending membership
 * (SKR-894). A row that never had an invitation sent removes nothing in WorkOS -
 * a normal case, so say what happened instead of overstating it.
 */
export function describeCancelInvitationResult(
  result: Pick<
    CancelUserInvitationResponse,
    "revokedCount" | "membershipDeactivated" | "membershipDeleted"
  >
): string {
  const revokedSomething =
    result.revokedCount > 0 ||
    result.membershipDeactivated ||
    result.membershipDeleted;

  return revokedSomething
    ? "The invite link no longer works."
    : "Cancelled in Skrift. There was nothing pending to revoke.";
}
